import PropTypes from 'prop-types';

import { colors } from 'styles/theme';

/**
 * @param {object} props
 */
function DipUtiLogo({
  width = '100%',
  height = '100%',
  viewBox = '0 0 134 41',
  color = colors.darkPurple,
  className = '',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
    >
      <g fill={color} fillRule="evenodd" stroke={color} strokeWidth=".4">
        <path
          fillRule="nonzero"
          d="M22.413 38.587v1.744a11.894 11.894 0 0 1-8.442-3.495l-9.71-9.71c-4.659-4.659-4.659-12.213 0-16.872 4.66-4.66 12.213-4.66 16.872 0l2.512 2.512-8.43 8.431c-3.979 3.978-3.979 10.428 0 14.406a10.15 10.15 0 0 0 7.198 2.984zM13.98 19.964l7.198-7.198-1.279-1.279c-3.978-3.978-10.428-3.978-14.406 0-3.978 3.978-3.978 10.428 0 14.406l5.33 5.33a11.924 11.924 0 0 1 3.157-11.259z"
        />
        <path
          fillRule="nonzero"
          d="M46.616 21.073L30.854 36.836a11.894 11.894 0 0 1-8.442 3.494v-1.743a10.15 10.15 0 0 0 7.198-2.984c3.978-3.978 3.978-10.428 0-14.406l-8.43-8.43L29.743 4.2c4.66-4.659 12.213-4.659 16.872 0l.256.256v.008c4.402 4.676 4.317 12.036-.256 16.608zM30.977 5.434l-7.332 7.332 7.198 7.198a11.923 11.923 0 0 1 3.158 11.259L45.383 19.84c3.978-3.978 3.978-10.428 0-14.406l-.031-.03c-3.98-3.948-10.407-3.937-14.375.03z"
        />
        <path
          fillRule="nonzero"
          d="M14.245 37.092h-.008l-.256-.256c-4.659-4.659-4.659-12.213 0-16.872l8.431-8.431 8.431 8.431c4.66 4.659 4.66 12.213 0 16.872a11.894 11.894 0 0 1-8.431 3.495 11.891 11.891 0 0 1-8.167-3.24zm.97-1.489a10.15 10.15 0 0 0 7.197 2.984 10.15 10.15 0 0 0 7.198-2.984c3.978-3.978 3.978-10.428 0-14.406L22.412 14l-7.198 7.198c-3.967 3.968-3.978 10.394-.03 14.375l.03.031z"
        />
        <path d="M112.464 15.359v10.315c0 2.782-2.175 5.167-4.956 5.218a5.05 5.05 0 0 1-5.145-5.05V15.359a.93.93 0 0 0-1.861 0v10.398c0 3.721 2.86 6.924 6.578 7.099a6.912 6.912 0 0 0 7.246-6.904V15.359a.93.93 0 1 0-1.862 0M75.798 18.267c.485 0 .878.393.878.877V32.16a.877.877 0 1 1-1.755 0V19.144c0-.484.393-.877.877-.877M74.774 15.4a1.024 1.024 0 1 1 2.049.001 1.024 1.024 0 0 1-2.049 0M91.64 25.41v-.5c-.002-3.071-2.215-5.385-5.071-5.385-2.855 0-5.067 2.31-5.072 5.38v.504c0 3.075 2.214 5.485 5.072 5.485s5.072-2.41 5.072-5.485zm1.666-.05c0 3.934-3.02 7.014-6.77 7.014-2.365 0-4.253-1.143-5.37-2.924v7.537a.877.877 0 1 1-1.755 0l.001-17.84a.877.877 0 0 1 1.755 0v1.729c1.116-1.781 3.004-2.925 5.37-2.925 3.746 0 6.765 2.978 6.769 6.909v.5zM133.545 15.359v16.748a.93.93 0 1 1-1.861 0V15.359a.93.93 0 0 1 1.861 0M128.587 14.429h-11.43a.93.93 0 1 0 0 1.86h4.784v15.87a.93.93 0 0 0 1.861 0V16.29h4.785a.93.93 0 1 0 0-1.86M63.678 31.283h-5.384v-15.1h5.384c4.17 0 7.057 3.38 7.057 7.55s-2.888 7.55-7.057 7.55m-.138-16.855h-6.178a.823.823 0 0 0-.823.823v16.963c0 .455.368.823.823.823h6.178a8.95 8.95 0 0 0 8.95-8.949v-.71a8.95 8.95 0 0 0-8.95-8.95" />
      </g>
    </svg>
  );
}

DipUtiLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default DipUtiLogo;
